module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-results"
  }, [_c('div', {
    staticClass: "search-input"
  }, [_c('search-autocomplete', {
    attrs: {
      "displayIcon": true,
      "displaySearchButton": true,
      "redirectOnSearch": false
    },
    on: {
      "search": _vm.search
    }
  })], 1), _vm._v(" "), (_vm.results && _vm.results.length > 0) ? _c('div', {
    staticClass: "search-result-tabs"
  }, [_c('search-tabs')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "search-result-row"
  }, [_c('div', {
    staticClass: "search-result-col-left"
  }, [(_vm.results && _vm.results.length > 0) ? _c('search-filter') : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "search-result-col-middle"
  }, [_c('div', {
    staticClass: "search-result-filters-mobile"
  }, [(_vm.results && _vm.results.length > 0) ? _c('search-filter', {
    attrs: {
      "isMobile": true
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.results && _vm.results.length > 0) ? _c('div', {
    staticClass: "search-result-options"
  }, [_c('search-option')], 1) : _vm._e(), _vm._v(" "), (_vm.results && _vm.results.length > 0) ? _c('div', {
    staticClass: "search-result-list"
  }, _vm._l((_vm.results), function(r) {
    return _c('search-item', {
      key: r.rank,
      attrs: {
        "item": r
      }
    })
  })) : _vm._e(), _vm._v(" "), (_vm.results && _vm.results.length > 0) ? _c('div', {
    staticClass: "search-result-pagination"
  }, [_c('search-paginator')], 1) : _vm._e(), _vm._v(" "), (
    _vm.relatedSearches &&
    _vm.relatedSearches.length > 0 &&
    _vm.results &&
    _vm.results.length > 0
  ) ? _c('div', {
    staticClass: "search-result-related"
  }, [_c('search-related')], 1) : _vm._e()])]), _vm._v(" "), (_vm.results && _vm.results.length === 0) ? _c('div', {
    staticClass: "search-result-empty"
  }, [_c('p', [_vm._v("No results... Please try another research.")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fd178db2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=8hbdlddx288!./~/string-replace-webpack-plugin/loader.js?id=ayyc1bnkec!./src/components/search/searchResult.vue
// module id = 430
// module chunks = 1